import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { DataResult } from "@progress/kendo-data-query";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AppConstant } from "src/app/app.constant";


@Injectable()
export class SPPAPPService {
    apiUrl: string;
    kendoDataUrl: string;
    constructor(private httpClient: HttpClient,
        private appConstant: AppConstant
        
        ) {
        this.apiUrl = "https://api.ssp.app.eduwity.com"
        // this.apiUrl = "http://localhost:11002"
    }

    // core  committee member 
    manageCoreCommittee(CoreCommittee) {
        return this.httpClient.post(`${this.apiUrl}/manageCoreCommittee`, CoreCommittee).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    getCoreCommitteeById(CoreCommitteeId) {
        return this.httpClient.get(`${this.apiUrl}/getCoreCommitteeById/` + CoreCommitteeId).pipe(
            map((response: any) => {
                return response;
            })
        )
    }

    public getAllCoreCommittee(state): Observable<DataResult> {
        return this.httpClient.post(`${this.apiUrl}/getAllCoreCommittee/`, state).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }

     // core Sambhag Prabhari  
     manageCoreSambhagPrabhari(CoreSambhagPrabhari) {
        return this.httpClient.post(`${this.apiUrl}/manageCoreSambhagPrabhari`, CoreSambhagPrabhari).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    getCoreSambhagPrabhariById(CoreSambhagPrabhariId) {
        return this.httpClient.get(`${this.apiUrl}/getCoreSambhagPrabhariById/` + CoreSambhagPrabhariId).pipe(
            map((response: any) => {
                return response;
            })
        )
    }

    public getAllCoreSambhagPrabhari(state): Observable<DataResult> {
        return this.httpClient.post(`${this.apiUrl}/getAllCoreSambhagPrabhari/`, state).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }

    // District President
    manageDistPresident(DistPresident) {
        return this.httpClient.post(`${this.apiUrl}/manageDistPresident`, DistPresident).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    getDistPresidentById(DistPresidentId) {
        return this.httpClient.get(`${this.apiUrl}/getDistPresidentById/` + DistPresidentId).pipe(
            map((response: any) => {
                return response;
            })
        )
    }

    public getAllDistPresident(state): Observable<DataResult> {
        return this.httpClient.post(`${this.apiUrl}/getAllDistPresident/`, state).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }

        // Block Prabhari
        manageBlockPrabhari(BlockPrabhari) {
            return this.httpClient.post(`${this.apiUrl}/manageBlockPrabhari`, BlockPrabhari).pipe(
                map((response: any) => {
                    return response;
                })
            )
        }
        getBlockPrabhariById(BlockPrabhariId) {
            return this.httpClient.get(`${this.apiUrl}/getBlockPrabhariById/` + BlockPrabhariId).pipe(
                map((response: any) => {
                    return response;
                })
            )
        }
    
        public getAllBlockPrabhari(state): Observable<DataResult> {
            return this.httpClient.post(`${this.apiUrl}/getAllBlockPrabhari/`, state).pipe(
                map((response: any) => {
                    return {
                        data: response.data,
                        total: response.total
                    } as GridDataResult
                })
            ) as any as Observable<GridDataResult>
        }

         // SSP Institute
        //  manageSSPInstitute(Institute) {
        //     return this.httpClient.post(`${this.apiUrl}/manageInstitute`, Institute).pipe(
        //         map((response: any) => {
        //             return response;
        //         })
        //     )
        // }
        getSSPInstituteById(InstituteId) {
            return this.httpClient.get(`${this.apiUrl}/getInstituteById/` + InstituteId).pipe(
                map((response: any) => {
                    return response;
                })
            )
        }
    
        public getSSPAllInstitute(state): Observable<DataResult> {
            return this.httpClient.post(`${this.apiUrl}/getAllInstitute/`, state).pipe(
                map((response: any) => {
                    return {
                        data: response.data.data,
                        total: response.total
                    } as GridDataResult
                })
            ) as any as Observable<GridDataResult>
        }

          // SSP Feed
         manageSSPFeed(Feed) {
            return this.httpClient.post(`${this.apiUrl}/manageFeed`, Feed).pipe(
                map((response: any) => {
                    return response;
                })
            )
        }
        getSSPFeedById(FeedId) {
            return this.httpClient.get(`${this.apiUrl}/getFeedById/` + FeedId).pipe(
                map((response: any) => {
                    return response;
                })
            )
        }
    
        public getSSPAllFeed(state): Observable<DataResult> {
            return this.httpClient.post(`${this.apiUrl}/getAllFeed/`, state).pipe(
                map((response: any) => {
                    return {
                        data: response.data.data,
                        total: response.total
                    } as GridDataResult
                })
            ) as any as Observable<GridDataResult>
        }
}